import { TicketOfficeView } from '../types/ticket-office';
import onScan from 'onscan.js';
import { addDiscount } from './props/app/discount-utils';

// Serial tickets and gift cards printed on Star printers before October 2026 carry a type
// prefix in the QR code ("SER-XJKZ-JDY8", "GC-XJKZ-JDY8"). Some readers drop the dashes, so
// the prefix is recognised by what remains: a card number is eight characters without them,
// while a ticket number is twelve.
const withoutCardPrefix = (code: string): string => {
    const match = code.match(/^(?:SER|GC)[-+]?(.+)$/i);

    return match && match[1].replace(/[-+]/g, '').length === 8 ? match[1] : code;
};

export const initBarcodeScanner = (view: TicketOfficeView): void => {
    const { lang } = view.state;

    onScan.attachTo(document, {
        onScan(scanned: string) {
            const code = withoutCardPrefix(scanned);
            let normalizedCode = code;

            // Handle barcode reader quirks
            if (code.includes('+')) {
                // Replace plus signs with dashes
                normalizedCode = code.replaceAll('+', '-');
            } else if (!code.includes('-')) {
                // If the reader cannot read pluses or dashes from the code, add them here between chunks of 4 chars.
                const chunks = [];
                let tempCode = code;
                while (tempCode.length > 0) {
                    chunks.push(tempCode.substring(0, 4));
                    tempCode = tempCode.substring(4, tempCode.length);
                }
                normalizedCode = chunks.join('-');
            }

            if (normalizedCode.length === 12) {
                window.location.href = '/admin2/ticket_validation/single?ticket_number=' + normalizedCode;
            } else {
                $.ajax({
                    type: 'GET',
                    url: view.state.urls.addDiscountService,
                    data: {
                        query: normalizedCode,
                    },
                    success(response) {
                        if (response.suggestions.length) {
                            addDiscount(view, response.suggestions[0]);
                            window.toastr.success(lang.discounts.cardAdded + normalizedCode);
                        } else {
                            window.toastr.warning(lang.discounts.cardNotFound + normalizedCode);
                        }
                    },
                    error(xhr) {
                        window.toastr.error(lang.errors.cardSearchRequestFailed);
                    },
                });
            }
        },
    });
};
